"use client"

import { useQueryClient } from "@tanstack/react-query"
import { usePubSub } from "./usePubSub"

export function useWarehouseSchedulingSync() {
    const queryClient = useQueryClient()

    usePubSub([
        {
            events: ["warehouseSchedulingUpdated"],
            callback: () => {
                try {
                    queryClient.invalidateQueries({
                        queryKey: [["warehouseScheduling"]],
                        refetchType: "active",
                    })
                } catch {
                    // Silent failure is acceptable for cache invalidation
                }
            },
        },
    ])
}
